export type MegaMenuContent = {
  href: string;
  label: string;
  name: string;
  type: MegaMenuContentType;
  onButtonClick?: () => void;
  footer?: MegaMenuContent;
  children?: MegaMenuContent[];
};

export const MEGAMENU_CONTENT_TYPE = {
  section: 'section',
  link: 'link',
  header: 'header',
} as const;

export type MegaMenuContentType = (typeof MEGAMENU_CONTENT_TYPE)[keyof typeof MEGAMENU_CONTENT_TYPE];
